import React from 'react';
import RichtextParser from '../../utils/richtext-parser';
import styled, { css } from 'styled-components';
import Container from '../container';
import mq from '../../utils/mq';

const CaseStudyTextTitleContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 20px;
  padding: 64px 0;
  ${mq.mobile(css`
    padding: 32px 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 20px;
  `)};
`;

const CaseStudyTextTitleContent = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 2 / span 10;
`;

const Label = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

const LabelText = styled.div`
  color: #666;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  letter-spacing: -0.15px;
`;

const LabelDecoration = styled.div`
  background: #813dff;
  width: 16px;
  height: 2px;
`;

const Title = styled.h2`
  color: #161616;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 115%;
  letter-spacing: -0.72px;
  margin-top: 22px;
  margin-bottom: 28px;
  ${mq.mobile(css`
    font-size: 32px;
  `)};
`;

const Content = styled.div`
  color: #666;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.4px;
  p {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
`;

export default function CaseStudyTextWithTitle({
  label,
  title,
  content
}: {
  label: any;
  title: any;
  content: any;
}) {
  return (
    <Container>
      <CaseStudyTextTitleContainer>
        <CaseStudyTextTitleContent>
          <Label>
            <LabelText>{label}</LabelText>
            <LabelDecoration />
          </Label>
          <Title>{title}</Title>
          <Content
            dangerouslySetInnerHTML={{ __html: RichtextParser(content) }}
          />
        </CaseStudyTextTitleContent>
      </CaseStudyTextTitleContainer>
    </Container>
  );
}
